module.exports = __webpack_public_path__ + "img/icon-success.ea430107.png";